// extracted by mini-css-extract-plugin
export default {"selectLangues":"styles_selectLangues__Rfh-A","language":"styles_language__7eUKb"};